import "./ColorPicker.scss";
import { colorOptions } from "../../utils/colors";

function ColorPicker({ selectedColor, onColorSelect }) {
  return (
    <div className="color-picker">
      {colorOptions.map((color) => (
        <div
          key={color}
          className={`color-option ${selectedColor === color ? "selected" : ""}`}
          style={{ backgroundColor: color }}
          onClick={() => onColorSelect(color)}
          title={color}
        />
      ))}
    </div>
  );
}

export default ColorPicker;
